// Scene images
import img_4 from './scenes_4.jpg';
import img_3 from './scenes_3.jpg';
import img_2 from './scenes_2.jpg';
import img_1 from './scenes_1.jpg';

export const sceneImages: Record<string, string> = {
  'scenes_4.jpg': img_4,
  'scenes_3.jpg': img_3,
  'scenes_2.jpg': img_2,
  'scenes_1.jpg': img_1,
};